import { Route } from '@angular/router';
import { LEASING } from '@rma/common-ui-domain/types';
import { logRedirectGuard, RmaEmptyComponent } from '@rma/generic/util/router-utils';

export const legacyRoutes: Route[] = [
  {
    path: 'agent/reviews/completed',
    canActivate: [logRedirectGuard('/reviews', { status: 'Completed' })],
    component: RmaEmptyComponent,
  },
  {
    path: 'agency/reviews/completed',
    canActivate: [logRedirectGuard('/reviews', { status: 'Completed' })],
    component: RmaEmptyComponent,
  },
  {
    path: 'agent/reviews/pending',
    canActivate: [logRedirectGuard('/reviews', { status: 'Pending' })],
    component: RmaEmptyComponent,
  },
  {
    path: 'agency/sales/reviews/completed',
    canActivate: [logRedirectGuard('/reviews', { status: 'Completed' })],
    component: RmaEmptyComponent,
  },
  {
    path: 'agency/sales/reviews/pending',
    canActivate: [logRedirectGuard('/reviews', { status: 'Pending' })],
    component: RmaEmptyComponent,
  },
  {
    path: 'agency/leasing/reviews/completed',
    canActivate: [logRedirectGuard('/reviews', { status: 'Completed', VERTICAL_TYPE_QUERY_PARAM: LEASING })],
    component: RmaEmptyComponent,
  },
  {
    path: 'agency/leasing/reviews/pending',
    canActivate: [logRedirectGuard('/reviews', { status: 'Pending', VERTICAL_TYPE_QUERY_PARAM: LEASING })],
    component: RmaEmptyComponent,
  },
  {
    path: 'agency/leasing/about',
    canActivate: [logRedirectGuard('/reviews', { VERTICAL_TYPE_QUERY_PARAM: LEASING })],
    component: RmaEmptyComponent,
  },

  {
    path: 'agency/sales/listings/unconfirmed',
    canActivate: [logRedirectGuard('/campaigns/sales', { statuses: 'Active' })],
    component: RmaEmptyComponent,
  },
  {
    path: 'agency/sales/listings/confirmed',
    canActivate: [logRedirectGuard('/campaigns/sales', { statuses: 'Sold' })],
    component: RmaEmptyComponent,
  },
  {
    path: 'agency/leasing/listings/unconfirmed',
    canActivate: [logRedirectGuard('/campaigns/leasing', { statuses: 'Active' })],
    component: RmaEmptyComponent,
  },
  {
    path: 'agency/leasing/listings/confirmed',
    canActivate: [logRedirectGuard('/campaigns/leasing', { statuses: 'Sold' })],
    component: RmaEmptyComponent,
  },
  {
    path: 'agent/listings/unconfirmed',
    canActivate: [logRedirectGuard('/campaigns/sales', { statuses: 'Active' })],
    component: RmaEmptyComponent,
  },
  {
    path: 'agent/listings/confirmed',
    canActivate: [logRedirectGuard('/campaigns/sales', { statuses: 'Sold' })],
    component: RmaEmptyComponent,
  },
];
